import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';    
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

// Components 

import Box from '@mui/material/Box';
import Button from '../../../general/inputs/Button';
import { setDashboardSection, setIsDeletedAccountPopupOpened, setIsGroupAccessInvitePopupOpened } from '../../../../redux/features/general/navigation';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { setNotificationMessage } from '../../../../redux/features/general/notification';
import { inviteDoctorToGroup } from '../../../../routes/doctor/account';
import { resetCreateGroupAccess } from '../../../../redux/features/doctor/group/createGroupAccess';
import { setIsRefreshGroupAccessList } from '../../../../redux/features/doctor/group/groupAccess';
import CancelButton from '../../../general/inputs/CancelButton';
import Popup from '../../../general/popups/items/Popup';

interface Props { 

}; 

const Invite: React.FC<Props> = ({ }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const { consultationId } = useParams(); 

    const colors = useAppSelector(state => state.theme.colors); 

    const email = useAppSelector(state => state.createGroupAccess.email); 

    // -- 

    const handleGroupAccessInvite = async () => { 

        const res = await inviteDoctorToGroup(email); 

        if (res?.data.status == 200) { 

            // Redux is reset. 

            dispatch(resetCreateGroupAccess()); 

            dispatch(setNotificationMessage(t('groupAccessCreated'))); 

            dispatch(setIsRefreshGroupAccessList(true)); 

            dispatch(setDashboardSection('groupAccessList'));

        } else { 


        }; 

        dispatch(setIsGroupAccessInvitePopupOpened(false)); 

    };

    // -- 

    const handleQuit = () => { 

        dispatch(setIsGroupAccessInvitePopupOpened(false)); 

    }; 
    
    // -- 

    return (

        <Popup>

            <Box
                component="img"
                sx={{
                    width: 100,
                    marginTop: 3, 
                    marginBottom: 2, 
                }}
                src={require('../../../../assets/icons/navigation/doctors.png')}
            />

            <Box
                sx={{ 
                    width: '50%',
                    marginBottom: 1 
                }}
            >{t('existingAccount')}

            </Box>

            <Button 
                title={'invite'}
                triggerFunction={handleGroupAccessInvite}
                extraStyle={{ width: 200, marginBottom: 4 }}
            />

            <CancelButton handler={handleQuit} extraStyle={{ fontSize: 30 }} />

        </Popup>

  );

};

export default Invite;